import type {
  ListingsAPIResponseNumericAttribute,
  ListingsAPIResponsePagination,
  ListingsAPIResponseProduct,
} from '@noths/polaris-client-listings-api';
import type { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import { deliveryZoneCodes } from '@noths/polaris-client-localisation';
import type { CurrencyCode, Navigation } from '@noths/polaris-dev-ts-types';

import type { RequestProductsActionProductsPayload } from 'src/redux/products/types';
import type { Product } from 'src/redux/products/types/Product';

interface AdaptResponseProductsToStoreArgs {
  attributionToken: string | null;
  currencyCode: CurrencyCode;
  deliveryZone: DeliveryZoneCode;
  pagination: ListingsAPIResponsePagination;
  products: ListingsAPIResponseProduct[];
  term: string;
}

export const adaptResponseProductsToStore = ({
  attributionToken,
  currencyCode,
  deliveryZone,
  pagination,
  products,
  term,
}: AdaptResponseProductsToStoreArgs): RequestProductsActionProductsPayload => {
  const category = null;
  const navigation: Navigation[] = [];
  const providerMetadata = { filter: '(attributes.delivery_zones = 1)' };
  const partner = null;

  const {
    currentPage,
    pageSize: perPage,
    resultsReturnedThisPage: productsReturnedCount,
    totalResults: totalProducts,
  } = pagination;

  const totalPages = Math.ceil(totalProducts / perPage);

  const adaptedProducts = products.map((product) => {
    const {
      attributes,
      freeDomesticDelivery,
      images,
      isSponsored,
      links,
      lowCommitmentProductFlag,
      lowCommitmentProductType,
      ...restOfProduct
    } = product;

    const isMainlandUKDeliveryZone = deliveryZone === deliveryZoneCodes[1];

    const deliveryCost = null;
    const deliveryDays = isMainlandUKDeliveryZone
      ? (attributes?.delivery_days as ListingsAPIResponseNumericAttribute)?.numbers?.[0] || null
      : null;

    return {
      ...restOfProduct,
      detailPageHref: links?.[0]?.rel || '',
      imageSrc: images?.[0]?.href || '',
      deliveryCost,
      deliveryDays,
    } as Product;
  });

  const result = {
    category,
    currencyCode,
    products: adaptedProducts,
    perPage,
    lastPageLoaded: currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    term,
    navigation,
    partner,
    providerAttributionToken: attributionToken || null,
    providerMetadata,
  };

  return result;
};
